module.exports = __webpack_public_path__ + "static/img/qr.a568967.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/img/qr.png
// module id = TyGa
// module chunks = 3